import { Title, Flex } from '@mantine/core';

import {
  WithdrawalsFilter,
  WithdrawalsTable,
  useGetWithdrawals,
} from '@/modules/withdrawals';

export const Withdrawals = () => {
  const {
    params,
    items: withdrawals,
    itemsCount: withdrawalsCount,
    isLoading,
    handleFilterChange,
    handleFilterReset,
    handlePaginationChange,
  } = useGetWithdrawals();

  return (
    <>
      <Flex justify="space-between" align="center" w="100%" mb={10}>
        <Title order={4}>Заявки на вывод</Title>
      </Flex>

      <WithdrawalsFilter
        onSubmit={handleFilterChange}
        onReset={handleFilterReset}
      />

      <WithdrawalsTable
        items={withdrawals}
        isLoading={isLoading}
        itemsCount={withdrawalsCount}
        pageSize={params.pageSize}
        currentPage={params.page}
        onPageChange={handlePaginationChange}
      />
    </>
  );
};
